export enum TileTypes {
  Dashboard = 1,
  Bar,
  Line,
  Circle,
  Count = 6,
  Report,
  Number,
}

export default interface TileType {
  id?: number;
  name: string;
  hasIcon?: boolean;
  hasXAxis?: boolean;
  hasYAxis?: boolean;
  hasFilters?: boolean;
  hasBackground?: boolean;
  hasReport?: boolean;
  hasThreshold?: boolean;
}
